import { ca } from '@cian/analytics';
import { TUser } from '@cian/api-models/monolith-python/cian-api/site/v1/get-user-data-by-request';
import { EDeviceType } from '../types/device';
import { IPageState } from '../types/page';

import { getAllProducs } from './trackings';
import { ONE_PAGE_LENGTH } from '../constants/pagination';
import { IFavoriteEntity } from '../types/results';

export function trackPageview(
  pageData: IPageState,
  user: TUser,
  favoriteEntities: IFavoriteEntity[],
  total: number,
  skipCount?: number,
) {
  ca('pageview', {
    category: 'page',
    action: 'newpage',
    name: 'newpage',
    label: 'open',
    ...getPageviewData(pageData, user, favoriteEntities, total, skipCount),
  });
}

export function getPageviewData(
  pageData: IPageState,
  user: TUser,
  favoriteEntities: IFavoriteEntity[],
  total: number,
  skipCount?: number,
) {
  const pageNumber = Math.ceil(favoriteEntities.length / ONE_PAGE_LENGTH) || 1;

  return {
    user: {
      abGroup: pageData.abGroup,
      isAuthorized: user.isAuthenticated,
      userId: user.isAuthenticated ? user.userId : undefined,
    },
    page: {
      listingType: 'list',
      sortType: 'default',
      pageNumber,
      offersQty: total,
      pageType: 'ListingFavorites',
      siteType: pageData.deviceType !== EDeviceType.Phone ? pageData.deviceType : 'mobile',
    },
    products: getAllProducs({ favoriteEntities, pageNumber, skipCount }),
  };
}
